import { compareDesc } from 'date-fns';

import { EvaluationRange, ViewDataRow, WpViewPercentageData } from '../../core';

export function createPercentageData(
    r: ViewDataRow,
    evalRanges: EvaluationRange[],
    selectedEvalRange: EvaluationRange,
): WpViewPercentageData {
    const index = [...evalRanges]
        .sort((a, b) => compareDesc(a.endDateDataRange, b.endDateDataRange))
        .indexOf(selectedEvalRange);
    const prevEvalRange =
        index === -1 || index + 1 >= evalRanges.length
            ? null
            : evalRanges[index + 1];
    const ret = _createPercentageData(r, selectedEvalRange, prevEvalRange);

    if (selectedEvalRange.tooltipComparisonRanges?.length > 0) {
        ret.comparisons = [];
        selectedEvalRange.tooltipComparisonRanges.forEach((cr) => {
            const cer = evalRanges.find(
                (er) => er.evaluationRangeIsOaMetricId === cr,
            );
            if (cer == null) {
                return;
            }
            const cd = r.comparisons?.find(
                (cd) =>
                    (cd.individual?.evaluationRangeId ??
                        cd.peopleDetail?.evaluationRangeId) ===
                    cer.evaluationRangeId,
            );
            ret.comparisons.push(_createPercentageData(cd, cer, null));
        });
    }

    return ret;
}

function _createPercentageData(
    r: ViewDataRow | null,
    evalRange: EvaluationRange | null,
    prevEvalRange: EvaluationRange | null,
): WpViewPercentageData {
    const pdRow = r?.individual ?? r?.peopleDetail;
    return {
        tooltipEnabled: false,
        winningPercentage: pdRow?.winning,
        winningBorderColour:
            pdRow?.winning === 0
                ? 'cmps-cdk-border-color-red-100'
                : 'cmps-cdk-border-color-grey-300',
        winningThresholdColour: pdRow?.winningThresholdColour,
        prevWinningPercentage: pdRow?.prevWinning,
        prevWinningThresholdColour: pdRow?.prevWinningThresholdColour,
        winningChange: pdRow?.winningChange,
        winningChangeIcon:
            pdRow?.winningChange > 0
                ? 'arrow-up'
                : pdRow?.winningChange < 0
                ? 'arrow-down'
                : 'arrow-left-right',
        winningChangeColour:
            pdRow?.winningChange > 0
                ? 'cmps-cdk-color-green-100'
                : pdRow?.winningChange < 0
                ? 'cmps-cdk-color-red-100'
                : '',
        evalRange,
        prevEvalRange,
        comparisons: null,
    };
}
